module.exports = __webpack_public_path__ + "img/DE01567.33a57571.png";